import React from 'react';
import { useParams } from 'react-router';

import Sidebar from 'common/Sidebar'
import BoardList from './Board/BoardList'
import BoardDetail from './Board/BoardDetail'
import BoardWrite from './Board/BoardWrite'

import db from 'service/db'

import { useSelector } from 'react-redux'

function Board() {
    let id = useSelector(state => state.userInfo.id);

    const params = useParams();
    const [posts, setPosts] = React.useState([])

    const titles = React.useMemo(() => {
        return {
            'article': '보도자료',
            'coachnotice': '코치과정공지',
            'donationhistory': '연간 기부금 모금액 내역',
            'donationusing': '기부금 활용 실적 내역',
            'matchresult': '대회결과',
            'matchschedule': '대회일정 및 신청',
            'notice': '공지사항',
            // 'participate': '온라인 참가신청',
            // 'qna': '문의게시판',
            'refereenotice': '심판과정공지',
        }
    }, []);

    React.useEffect(() => {
        if (Object.keys(titles).indexOf(params.root) >= 0) {
            db.getAllDb(params.root).then(result => {
                setPosts(result)
            })
        } else {
            window.location.assign('/empty')
        }
    }, [params.root, titles])
    console.log(params)

    function previous() {
        for (let i = 1; i < posts.length; i++) {
            if (posts[i].id === params.id * 1) {
                return posts[i - 1];
            }
        }
        return {}
    }

    function next() {
        for (let i = 0; i < posts.length - 1; i++) {
            if (posts[i].id === params.id * 1) {
                return posts[i + 1];
            }
        }
        return {}
    }

    function upload(title, data, rowid) {
        if (id) {
            if (rowid) {
                db.putAllDbById(params.root, { title: title, contents: data, id: rowid }).then(item => {
                    alert("수정 되었습니다.")
                    window.location.assign(`/${params.root}`)
                }).catch(e => {
                    alert("수정이 실패했습니다. 본문의 내용을 확인해주세요")
                })
            } else {
                db.postAllDb(params.root, { title: title, contents: data }).then(item => {
                    alert("업로드 되었습니다.")
                    window.location.assign(`/${params.root}`)
                }).catch(e => {
                    alert("업로드가 실패했습니다. 본문의 내용을 확인해주세요")
                })
            }
        } else {
            alert("로그인 정보가 없습니다.")
        }
    }

    function Rendering() {
        if (id === '') {
            if (params.id * 1 > 0) {
                console.log(posts)
                if (posts.filter(i => i.id === params.id * 1).length !== 0) {
                    return <BoardDetail data={posts.filter(i => i.id === params.id * 1)[0]} root={params.root} prev={previous()} next={next()} />
                } else {
                    return <BoardList posts={posts} title={titles[params.root]} root={params.root} />
                }
            } else {
                return <BoardList posts={posts} title={titles[params.root]} root={params.root} />
            }
        }
        else if (params.id === 'write') {
            if (params.rowid)
                return <BoardWrite upload={upload} post={posts.filter(i => i.id === params.rowid * 1)[0]} />
            else
                return <BoardWrite upload={upload} />
        } else if (params.id) {
            if (posts.filter(i => i.id === params.id * 1).length !== 0) {
                return <BoardDetail data={posts.filter(i => i.id === params.id * 1)[0]} root={params.root} prev={previous()} next={next()} />
            } else
                return <BoardList posts={posts} title={titles[params.root]} root={params.root} />
        } else {
            return <BoardList posts={posts} title={titles[params.root]} root={params.root} />
        }
    }

    return (
        <div className="container">
            <div className="row ">
                <div className="d-none d-xl-block col-3 m-0 px-0">
                    <Sidebar root={params.root} title={titles[params.root]} />
                </div>
                <div className="col-12 col-xl-9 px-0">
                    <Rendering />
                </div>
            </div>
        </div>
    );
}

export default Board;